// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgotPasswordContainerWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
}

.reset_email_message {
    position: absolute;
    right: 65%;
    top: 31%;
    width: 400px;
    line-height: 30px;
}

.forgotPassword_email_message {
    position: absolute;
    right: 70%;
    top: 10%;
    width: 400px;
    line-height: 30px;
}

.buttonAndText {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.submit_btn {
    position: relative;
}

.forgotPassword_loder {
    position: absolute;
    height: 50px;
    top: -6px;
    left: 50px;
}

.width {
    width: 700px;
}

@media (max-width: 991.98px) {
    .width {
        width: 500px;
    }

}

/*********** mobile view ***********/
@media (max-width: 575.98px) {
    .width {
        width: 300px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Global/ForgotPassword/ForgotPassword.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,YAAY;IAChB;;AAEJ;;AAEA,oCAAoC;AACpC;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":[".forgotPasswordContainerWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100vh;\n}\n\n.reset_email_message {\n    position: absolute;\n    right: 65%;\n    top: 31%;\n    width: 400px;\n    line-height: 30px;\n}\n\n.forgotPassword_email_message {\n    position: absolute;\n    right: 70%;\n    top: 10%;\n    width: 400px;\n    line-height: 30px;\n}\n\n.buttonAndText {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.submit_btn {\n    position: relative;\n}\n\n.forgotPassword_loder {\n    position: absolute;\n    height: 50px;\n    top: -6px;\n    left: 50px;\n}\n\n.width {\n    width: 700px;\n}\n\n@media (max-width: 991.98px) {\n    .width {\n        width: 500px;\n    }\n\n}\n\n/*********** mobile view ***********/\n@media (max-width: 575.98px) {\n    .width {\n        width: 300px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
